const apiUrls = {
  logsUrl: '/Users/Api/v1/Logs',
  logsEntities: '/Catalogs/Api/v1/FixedCatalogs/LogTypesEntities',
  logTypes: '/Catalogs/Api/v1/FixedCatalogs/LogTypesList',
  logUsers: '/Catalogs/Api/v1/FixedCatalogs/LogUsers',
};

export default apiUrls;
